import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useHttp } from '../../../hooks/http';
import { useAuth } from '../../../hooks/auth';

/** components */
import Layout from '../../../components/Layout';
import Address from '../Address';

import {
  HandsHelpingIcon,
} from '../../../styles/icons';

import { Container, WrapperAddress } from './styles2';
import Proximity from '.';

interface ICoord {
  lat: number;
  lng: number;
}

interface IService {
  id: string;
}

const OrderProximity: React.FC = () => {
  const history = useHistory();
  const { httpGet, loading } = useHttp();
  const { user } = useAuth();
  const [coord, setCoords] = useState<ICoord>({} as ICoord);
  const [service, setService] = useState<IService | null>(null);

  useEffect(() => {
    async function load(): Promise<any> {
      const management_id = user?.allocation?.management_id;
      const { status, data } = await httpGet(`/orders/auth/${management_id}`);

      if (status === 200) {
        setService(data);
        return;
      }

      setService(null);
      history.push('/dashboard');
    }

    load();
  }, [history, httpGet, user]);

   const breadcrumbs = {
    icon: HandsHelpingIcon,
    links: [{ path: '', title: 'Proximidade' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs} loading={loading}>
      <Container>
        {!coord.lat && service && (
          <WrapperAddress>
            <h3><span>Selecione o </span>local da abordagem</h3>
            <Address
              handleCoord={(coord: ICoord) => {
                setCoords(coord);
              }}
            />
          </WrapperAddress>
        )}
        {coord.lat && (
          <Proximity coord={coord} />
        )}
      </Container>
    </Layout>
  );
};

export default OrderProximity;
